<template>

  <a 
    href="javascript:void(0)" 
    @click.stop="parseResume(candidate._id)" 
    class="btn btn-sm btn-light" 
    :class="{'box-loading': loading}">
    {{ $t('Extract resume data') }}
    </a>

</template>

<script>
export default {
  name: 'CandidateProfileCoverLetter',
  components: {
  },
  data () {
    return {
      loading: false,
      sectionEdit: false,
      candidateEdit: {},
      validateErrors: false
    }
  },
  created () {
  },
  computed: {
    candidate () {
      return this.$store.getters.getCandidate
    }
  },
  methods: {
    alertNoCredits () {
      this.$store
      .dispatch('setAlertModal', {
        type: 'ok',
        title: 'Sem créditos para extração de currículos.',
        message: 'Contate o administrador.'
      })
    },
    parseResume (id) {
      this.loading = true

      this.$store.dispatch('parseResume', id).catch(err => {
        if (err.response.data.name === 'Forbidden') {
          this.alertNoCredits()
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Profile/CandidateProfileResumeParse.vue